module.exports = __webpack_public_path__ + "img/index_yxjs.6e1a6972.svg";